"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var get_1 = __importDefault(require("lodash/fp/get"));
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var react_redux_firebase_1 = require("react-redux-firebase");
var react_router_dom_1 = require("react-router-dom");
var ButtonWithModal_1 = require("atomicComponents/organisms/Button/ButtonWithModal");
var TabbedStackLayout_1 = __importDefault(require("atomicComponents/organisms/Layout/TabbedStackLayout"));
var SortHoC_1 = __importDefault(require("atomicComponents/organisms/SortableHeader/SortHoC"));
var HudledHelmet_1 = __importDefault(require("containers/App/HudledHelmet"));
var Loadable_1 = __importDefault(require("containers/NotFoundPage/Loadable"));
var BatchLoadFilteredTable_1 = __importDefault(require("containers/TableMaker/BatchLoadFilteredTable"));
var populatedDerived_1 = require("utils/selectors/populatedDerived");
var single_1 = require("utils/selectors/single");
var constants_1 = require("../constants");
var AcceptAgreementsModal_1 = __importDefault(require("./AcceptAgreementsModal"));
var tableConf_1 = require("./tableConf");
var utils_1 = require("./utils");
var Table = (0, BatchLoadFilteredTable_1.default)(tableConf_1.tableConf, utils_1.filterGroupDefinitions, [
    (0, get_1.default)('name'), (0, get_1.default)('rechCustomer.name'),
    (0, utils_1.getAddressPart)('country'), (0, utils_1.getAddressPart)('city'), (0, utils_1.getAddressPart)('state'), (0, utils_1.getAddressPart)('postalCode'),
    (0, utils_1.getAddressPart)('line1'), (0, utils_1.getAddressPart)('line2'),
]);
var FILTER_MAP = {
    'for-review': function (crawledMigrationCustomer, landingTime) {
        var _a, _b;
        return !((_b = (_a = crawledMigrationCustomer.rechCustomer) === null || _a === void 0 ? void 0 : _a.crawledMigrationCustomer) === null || _b === void 0 ? void 0 : _b.confirmedOn)
            || crawledMigrationCustomer.rechCustomer.crawledMigrationCustomer.confirmedOn.toDate() > landingTime;
    },
    confirmed: function (crawledMigrationCustomer) { var _a, _b; return (_b = (_a = crawledMigrationCustomer.rechCustomer) === null || _a === void 0 ? void 0 : _a.crawledMigrationCustomer) === null || _b === void 0 ? void 0 : _b.confirmedOn; },
    all: function () { return true; },
};
var MigrateCustomers = function () {
    var filterKey = (0, react_router_dom_1.useParams)().filterKey;
    var rechargerCompany = (0, react_redux_1.useSelector)(single_1.selectMyRechargerCompany);
    (0, react_redux_firebase_1.useFirestoreConnect)(function () { return [{ collection: 'crawled_migration_customer', where: ['companyId', '==', rechargerCompany === null || rechargerCompany === void 0 ? void 0 : rechargerCompany.id] }]; });
    var _a = __read(react_1.default.useState(new Date()), 2), landingTime = _a[0], setLandingTime = _a[1];
    react_1.default.useEffect(function () { return setLandingTime(new Date()); }, [filterKey]);
    var filterFunction = FILTER_MAP[filterKey];
    var filterFn = function (items) { return items === null || items === void 0 ? void 0 : items.filter(function (customer) { return filterFunction(customer, landingTime); }); };
    var customersToAuthorizeAgreementsFor = (0, react_redux_1.useSelector)(populatedDerived_1.selectCustomersToAcceptAgreement);
    if (!filterFunction) {
        return (0, jsx_runtime_1.jsx)(Loadable_1.default, {});
    }
    return ((0, jsx_runtime_1.jsxs)(TabbedStackLayout_1.default, __assign({ tabs: constants_1.CRAWLED_CUSTOMERS_MIGRATION_TABS }, { children: [(0, jsx_runtime_1.jsx)(HudledHelmet_1.default, { title: "Recharges - Customers Migration", description: "Recharges - Customers Migration" }), (0, jsx_runtime_1.jsx)(Table, { filterFunction: filterFn, toolbarProps: { gap: 2, mb: 1.25 }, toolbarContent: {
                    pre: customersToAuthorizeAgreementsFor && ((0, jsx_runtime_1.jsx)(ButtonWithModal_1.LineBtnWithModal, __assign({ modalComponent: AcceptAgreementsModal_1.default, color: "neutral", size: "small" }, { children: "Finalise migration" }))),
                } })] })));
};
exports.default = (0, SortHoC_1.default)(MigrateCustomers, { key: 'name', order: 1 });
